module.exports = __webpack_public_path__ + "img/10.54c9b7c8.png";